module.exports = __webpack_public_path__ + "assets/GoldRho.f85172207b470675c59fc102a7460187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldRho.png
// module id = 773
// module chunks = 0